import { Extension } from "@tiptap/core";

// Tiptap changed how they handle select all in December 2024 to use ProseMirror's AllSelection
// rather than their internal TextSelection. They previous said they intentionally avoid ProseMirror's
// AllSelection because of how it doesn't work with some of their features.
// This custom extension fixes that by using the old behavior from their package.
// related change: https://github.com/ueberdosis/tiptap/pull/5900/files
export const SelectAllExtension = Extension.create({
  name: "selectAllFix",

  addCommands() {
    return {
      selectAll:
        () =>
        ({ tr, commands }) => {
          return commands.setTextSelection({
            from: 0,
            to: tr.doc.content.size,
          });
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-a": () => this.editor.commands.selectAll(),
    };
  },
});

export default SelectAllExtension;
